// extracted by css-extract-rspack-plugin
export default {"root":"root-DeuFS5 content-NFrjKj","inputGroup":"inputGroup-kLuuJp inputGroup-p0rCaE"};